export default __webpack_public_path__ + "static/1-55f284631b9f481ab3b849b5f8232b20.jpg";